import type { FiltersWidgetStateParams } from '@repo/go-widgets/filters';
import { action, makeObservable, observable } from 'mobx';

import { WidgetEntity } from 'src/entities/widget/WidgetEntity';
import type { SizeBoundaries, TWidgetOptions } from 'src/entities/widget/WidgetEntity';
import { requireService } from 'src/packages/di';

interface FiltersWidgetOptions {
  type: string;
  stateParams: FiltersWidgetStateParams;
}

export type TFiltersSerializedInternalState = {
  stateParams: FiltersWidgetStateParams;
};

export class FiltersWidgetEntity extends WidgetEntity {
  readonly sizeBoundaries: SizeBoundaries = {
    minInPixels: {
      w: 280,
      h: 464,
    },
    maxInPixels: {
      w: 560,
    },
    min: {
      w: 37,
      h: 50,
    },
    max: {
      w: 93,
      h: 100,
    },
  };

  @observable type: string;
  @observable.ref stateParams: FiltersWidgetStateParams;

  private disposeHostStore: (() => void) | null = null;

  constructor(
    { type, stateParams }: FiltersWidgetOptions,
    widgetOptions: TWidgetOptions,
    private readonly i18 = requireService('i18'),
  ) {
    super(widgetOptions);

    this.type = type;
    this.stateParams = stateParams;

    makeObservable(this);
  }

  getNameT(): string {
    return 'wellsFilter:title';
  }

  @action.bound
  setFullscreen(value: boolean): void {
    this.isFullscreen = value;
  }

  @action.bound
  setStateParams(stateParams: FiltersWidgetStateParams): void {
    this.stateParams = stateParams;
  }

  get isControlWidget(): boolean {
    return true;
  }

  get title(): string {
    return this.i18.t(this.getNameT());
  }

  @action.bound
  setDisposeHostStore(dispose: (() => void) | null): void {
    this.disposeHostStore = dispose;
  }

  override destroy() {
    this.disposeHostStore?.();
    this.disposeHostStore = null;
  }
}
